import { cn } from "../../utils";
import { Text } from "../Typography";
import type { MenuHeader as MenuHeaderType } from "./types";

type Props = {
  item: MenuHeaderType;
};

export const MenuHeader = ({ item }: Props) => {
  return (
    <div className={cn("px-2 py-2", item.className)}>
      <Text size="sm" weight="medium">
        {item.text}
      </Text>
    </div>
  );
};
